import { TSegment } from '@/features/segments/types';

type PresenceCollectionKey = 'segment_logos' | 'segment_peoples';

type PresenceItem<K extends PresenceCollectionKey> = NonNullable<TSegment[K]>[number];

type SelectPresenceCollectionContext = {
  isGlobalView: boolean;
  activeSegment: TSegment | null;
  globalViewSegments: TSegment[];
};

function selectPresenceCollection<K extends PresenceCollectionKey, Kind extends string>(
  ctx: SelectPresenceCollectionContext,
  collectionKey: K,
  kind: Kind
): Array<PresenceItem<K> & { kind: Kind }> {
  const segments = ctx.isGlobalView
    ? ctx.globalViewSegments
    : ctx.activeSegment
      ? [ctx.activeSegment]
      : [];

  return segments.flatMap(segment => {
    const collection = (segment[collectionKey] ?? []) as PresenceItem<K>[];
    return collection.map(item => ({ ...item, kind }));
  });
}

export { selectPresenceCollection };
export type { PresenceCollectionKey, PresenceItem, SelectPresenceCollectionContext };
